import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Bis11Service } from 'src/app/services/bis11.service';
import { TestService } from 'src/app/services/test.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-bis11',
  templateUrl: './bis11.component.html',
  styleUrls: ['./bis11.component.css']
})
export class Bis11Component implements OnInit {
  public questions=[];
  public answers=[];
  public started=false;
  public texts;
  public selected = [];
  public testData;
  public photoTaked = false;
  public trigger = false;
  @ViewChild('instructions') instructions: ElementRef;

  constructor(
    private testService:TestService,
    private bis11Service:Bis11Service,
    public router:Router
  ) { }

  ngOnInit(): void {

    this.bis11Service.getQuestions().subscribe(
      resp=>{
        this.questions = resp;
      },
      err=>console.log(err)
    )

    if(!this.testService.selectedTestData){
      this.router.navigateByUrl('dashboard/requestedTests');
    }
    this.testData = this.testService.selectedTestData;
  }

  reload(){
    location.reload()
  }

  ngAfterViewInit(){
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
        setTimeout(()=>{
          this.instructions.nativeElement.innerHTML = this.texts.bis11Instructions;
        }, 500)
      },
      err=>console.log(err)
    )
  }

  startTest(){
    this.testService.testStarted = true;

    if (this.testData.camera){
      setTimeout(() => {
        this.trigger = !this.trigger;
      }, Math.floor(Math.random() * 60000 + 240000));
    }
    var testData = this.testService.selectedTestData;
    testData.isStarted = true;
    testData.startDate = Date.now();
    this.testService.updateTest(testData).subscribe();
    this.started=true;
  }

  nextSerie(){
    for (let j of this.selected){
      this.answers.push(j)
    }
    let complete = true;
    if (this.selected.length==0) complete = false;
    this.answers.map(
      a=>{
        if (a!='A'&&a!='B'&&a!='C'&&a!='D') complete = false
      }
    )
    if (complete){
      this.trigger = !this.trigger;
      this.started=false;
      Swal.fire({
        text:'Has concluido esta evaluación. Agradecemos tu participación',
        icon:'success',
        confirmButtonText:'Salir'
      });
      var data={
        answers:this.answers,
      }
      this.bis11Service.createReport(data).subscribe(
        res=>{
          var testData = this.testService.selectedTestData;
          testData.isCompleted = true;
          testData.reportId = res._id;
          testData.completeDate = Date.now();
          this.testService.updateTest(testData).subscribe(
            r=>{
              this.router.navigateByUrl('dashboard/requestedTests');
            },
            e=>console.log(e)
          );
        },
        err=> console.log(err)
      )
    }else{
      Swal.fire({
        icon:'info',
        text:'Debe responder todos los ítems'
      })
    }
    this.answers = [];
  }
}
